export default __webpack_public_path__ + "static/media/materialui.b3f1f3b1.avif";